<div class="contractor-details-inline">
  <div class="details-header">
    <h2>Contractor Details</h2>

    <!--<button
      type="button"
      class="close-btn"
      aria-label="Close contractor details"
      (click)="closeDetails()"
    >
      <span class="material-icons">close</span>
    </button>-->
  </div>

  <div
    class="details-body"
    *ngIf="!isLoading && registration"
  >
    <div class="title-row">
      <h1>Compliance Documents</h1>

      <span>
        {{ registration.contractor?.businessName }}
      </span>
    </div>

    <section class="registration-detail-card">
      <div class="registration-title-row">
        <h3>
          {{ registration.type?.name }}

          <span class="status-badge">
            {{ RegistrationStatus[registration.status] }}
          </span>
        </h3>
      </div>

      <div class="registration-details-grid">
        <div class="detail-field">
          <label>Registered On</label>
          <span>
            {{ registration.registeredOnString || '-' }}
          </span>
        </div>

        <div class="detail-field">
          <label>Approved On</label>
          <span>
            {{ registration.approvedOnString || '-' }}
          </span>
        </div>

        <div class="detail-field">
          <label>Effective On</label>
          <span>
            {{ registration.effectiveOnString || '-' }}
          </span>
        </div>

        <div class="detail-field">
          <label>Expires On</label>
          <span>
            {{ registration.expiresOnString || '-' }}
          </span>
        </div>

        <div class="detail-field">
          <label>Payment Method</label>
          <span>
            {{
              registration.paymentRequest?.paymentMethod ||
                '-'
            }}
          </span>
        </div>

        <div class="detail-field">
          <label>Payment Amount</label>
          <span>
            {{
              registration.paymentRequest?.requestedAmount
                ? (registration.paymentRequest
                    ?.requestedAmount | currency)
                : '-'
            }}
          </span>
        </div>
      </div>

      <a
        class="certificate-link"
        *ngIf="registration.certificateDocument"
        [href]="
          getAzureDocumentPath(
            registration.certificateDocument
          )
        "
        target="_blank"
        rel="noopener noreferrer"
      >
        View Certificate
      </a>
    </section>

    <section
      class="details-section"
      *ngIf="contractorRequirementFields?.length"
    >
      <h3>Contractor Requirements</h3>

      <wm-contractor-custom-field-list
        [customFields]="contractorRequirementFields"
        [form]="contractorForm"
        #customFields
      >
      </wm-contractor-custom-field-list>

      <div class="requirement-save-row">
        <wm-common-button
          class="section-save-btn"
          [data]="{
            text: savingContractorRequirements
              ? 'SAVING...'
              : 'SAVE',
            variant: 'raised',
            type: 'button',
            disabled:
              contractorForm.invalid ||
              savingContractorRequirements,
            onClick: saveContractorDetails.bind(this)
          }"
        >
        </wm-common-button>
      </div>
    </section>

    <section
      class="details-section"
      *ngIf="registrationRequirementFields?.length"
    >
      <h3>Registration Requirements</h3>

      <wm-contractor-custom-field-list
        [customFields]="registrationRequirementFields"
        [form]="rcfForm"
        #registrationCustomFields
      >
      </wm-contractor-custom-field-list>

      <div class="requirement-save-row">
        <wm-common-button
          class="section-save-btn"
          [data]="{
            text: savingRegistrationRequirements
              ? 'SAVING...'
              : 'SAVE',
            variant: 'raised',
            type: 'button',
            disabled:
              rcfForm.invalid ||
              savingRegistrationRequirements,
            onClick:
              saveRegistrationCustomFields.bind(this)
          }"
        >
        </wm-common-button>
      </div>
    </section>

    <section class="details-section">
      <div class="section-header">
        <div>
          <h3>Registration Documents</h3>
          <p>Use the upload button to add new docs</p>
        </div>
      </div>

      <wm-contractor-document-list
        [documents]="documents"
        [parentId]="registrationId"
        [showUploadPreview]="true"
        (saved)="saveDocument($event)"
        (deleted)="deleteDocument($event)"
        (added)="addNewDocuments($event)"
      >
      </wm-contractor-document-list>
    </section>

    <section class="details-section">
      <div class="section-header">
        <div>
          <h3>Contractor Documents</h3>
          <p>Use the upload button to add new docs</p>
        </div>
      </div>

      <wm-contractor-document-list
        [documents]="contractorDocuments"
        [parentId]="contractorId"
        [showUploadPreview]="true"
        (saved)="saveContractorDocument($event)"
        (deleted)="deleteContractorDocument($event)"
        (added)="addNewContractorDocuments($event)"
      >
      </wm-contractor-document-list>
    </section>

    <section
      class="details-section additional-fields-section"
      *ngIf="registration.customFields?.length"
    >
      <h3>Additional Fields</h3>

      <wm-contractor-custom-field-list
        [customFields]="registration.customFields"
        [form]="form"
        [isReadOnly]="true"
      >
      </wm-contractor-custom-field-list>
    </section>

    <section class="details-section notes-section">
      <div class="notes-header">
        <h3>Notes</h3>

        <wm-common-button
          class="add-note-btn"
          [data]="{
            text: 'ADD NOTE',
            variant: 'raised',
            type: 'button',
            onClick: openAddNoteModal.bind(this)
          }"
        >
        </wm-common-button>
      </div>

      <div
        class="notes-table-wrapper"
        *ngIf="registration.notes?.length; else noNotes"
      >
        <table class="notes-table">
          <thead>
            <tr>
              <th>Notes</th>
              <th>Created By</th>
              <th>Created On</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let note of registration.notes">
              <td class="note-content">
                {{ note.notes || '-' }}
              </td>

              <td>
                {{ note.createdBy || '-' }}
              </td>

              <td>
                {{
                  note.createdOn
                    ? (note.createdOn
                        | date: 'M/d/yyyy h:mm a')
                    : '-'
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #noNotes>
        <div class="notes-empty-state">
          No notes have been added.
        </div>
      </ng-template>
    </section>
  </div>

  <div class="loading-text" *ngIf="isLoading">
    Loading contractor details...
  </div>

  <wm-common-overlay-modal
    *ngIf="showAddNoteModal"
    class="add-note-overlay"
    [isOpen]="true"
    [style.top.px]="modalTop"
    [style.left.px]="modalLeft"
    [style.width.px]="modalWidth"
    [style.height.px]="modalHeight"
    headerTitle="Add Note"
    maxWidth="94%"
    minHeight="320px"
    (closed)="closeAddNoteModal()"
  >
    <div class="add-note-modal-content">
      <div class="note-form-group">
        <label for="manualNote" class="note-label">
          Note <span class="required-indicator">*</span>
        </label>

        <textarea
          id="manualNote"
          class="note-input"
          rows="4"
          maxlength="1000"
          [(ngModel)]="manualNote"
          [disabled]="savingNote"
        ></textarea>

        <div class="note-input-footer">
          <span
            class="note-validation"
            *ngIf="!manualNote?.trim()"
          >
            Note is required
          </span>

          <span class="note-character-count">
            {{ manualNote?.length || 0 }}/1000
          </span>
        </div>
      </div>
    </div>

    <div modal-footer>
      <wm-common-button
        class="note-modal-btn note-modal-btn-light"
        [data]="{
          text: 'CANCEL',
          variant: 'raised',
          type: 'button',
          disabled: savingNote,
          onClick: closeAddNoteModal.bind(this)
        }"
      >
      </wm-common-button>

      <wm-common-button
        class="note-modal-btn note-modal-btn-primary"
        [data]="{
          text: savingNote ? 'SAVING...' : 'ADD NOTE',
          variant: 'raised',
          type: 'button',
          disabled: savingNote || !manualNote?.trim(),
          onClick: addNote.bind(this)
        }"
      >
      </wm-common-button>
    </div>
  </wm-common-overlay-modal>
</div>
